<template>
  <v-row>
    <v-col cols="12">
      <!-- list filters -->
      <v-card class="pt-5">
        <v-card-title> Filtrar </v-card-title>

        <v-form
          @submit.prevent="downloadExcelRelatorio"
        >
          <v-row class="px-2 ma-0">
            <v-col
              cols="12"
              sm="2"
            >
              <VSelect
                v-model="equipeSelecionada"
                :items="equipes"
                item-text="nome"
                item-value="id"
                label="Equipe"
                outlined
                dense
                :rules="[validators.select]"
                @click="getEquipes"
                @change="handleSelecionarEquipe"
              />
            </v-col>

            <v-col
              cols="12"
              sm="3"
            >
              <VSelect
                v-model="agenteSelecionado"
                :items="agentes"
                item-text="nome"
                item-value="idIntegrante"
                label="Agente"
                outlined
                dense
                clearable
                hide-details
                @change="getRelatorioEquipe"
              />
            </v-col>

            <v-col
              cols="12"
              md="2"
              sm="4"
            >
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateFormatted"
                    label="Período de:"
                    outlined
                    dense
                    clearable
                    color="primary"
                    hide-details
                    v-bind="attrs"
                    :rules="[validators.required]"
                    v-on="on"
                    @blur="filtroPeriodoInicio = parseDate(dateFormatted)"
                  />
                </template>

                <v-date-picker
                  v-model="filtroPeriodoInicio"
                  no-title
                  color="primary"
                  locale="pt-br"
                  @change="getRelatorioEquipe"
                  @input="menu1 = false"
                />
              </v-menu>
            </v-col>

            <v-col
              cols="12"
              md="2"
              sm="6"
            >
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="computedDateFormatted"
                    label="Período até:"
                    outlined
                    dense
                    clearable
                    hide-details
                    v-bind="attrs"
                    :rules="[validators.required]"
                    v-on="on"
                    @blur="filtroPeriodoFim = parseDate(computedDateFormatted)"
                  />
                </template>

                <v-date-picker
                  v-model="filtroPeriodoFim"
                  no-title
                  color="primary"
                  locale="pt-br"
                  @change="getRelatorioEquipe"
                  @input="menu2 = false"
                />
              </v-menu>
            </v-col>

            <v-col
              cols="12"
              md="2"
              sm="12"
              class="d-flex justify-start text-right"
            >
              <v-btn
                color="primary"
                type="submit"
                :loading="loadingButton"
              >
                <v-icon>{{ icons.mdiFileExcelOutline }}</v-icon>
                <span>Exportar</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>

      <v-row>
        <v-col
          cols="12"
        >
          <relatorioEquipe
            :relatorio-data="relatorioData"
            :loading.sync="loading"
            :array-vazio="arrayVazio"
            :grouped-data="groupedDataDisplay"
          />
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { mdiFileExcelOutline } from '@mdi/js'
import { required, select } from '@core/utils/validation'
import ExcelJS from 'exceljs'
import * as FileSaver from 'file-saver'
import Vue from 'vue'
import { storeToRefs } from 'pinia'
import RelatorioEquipe from '@/views/relatorio/equipe/RelatorioEquipe.vue'
import RelatorioService from '@/services/modules/RelatorioService'
import EquipeService from '@/services/modules/EquipeService'
import useUserStore from '@/store/user'
import { getDataFinalMes, getDataInicialMes } from '@/utils/dateTime'

export default {
  components: {
    RelatorioEquipe,
  },

  setup() {
    const equipes = ref([])
    const agentes = ref([])

    const equipeSelecionada = ref('')
    const agenteSelecionado = ref('')

    const loading = ref(false)
    const loadingButton = false
    const arrayVazio = ref(false)

    const handleSelecionarEquipe = () => {
      agenteSelecionado.value = null
    }

    const relatorioData = ref([])

    const groupedDataDisplay = computed(() => {
      const relatorioAgrupadoPorData = relatorioData.value.reduce((groups, item) => {
        const date = item.dataRegistroLogin.split('T')[0]

        if (!groups[date]) {
          // eslint-disable-next-line no-param-reassign
          groups[date] = []
        }
        groups[date].push(item)

        return groups
      }, {})

      return Object.keys(relatorioAgrupadoPorData).reduce((acc, date) => {
        const items = relatorioAgrupadoPorData[date]

        const agenteIdArr = Array.from(new Set(items.map(it => it.agenteId)))

        acc[date] = agenteIdArr.map(agenteId => {
          const linhasDoAgenteNaData = relatorioAgrupadoPorData[date].filter(it => it.agenteId === agenteId)
          const filasDoAgente = linhasDoAgenteNaData.map(it => it.filaNome).sort()

          const {
            agenteNome, tempoLogado, tempoEmPausa, data,
          } = linhasDoAgenteNaData[0]

          return {
            agenteId, agenteNome, tempoLogado, tempoEmPausa, data, filas: filasDoAgente,
          }
        })

        return acc
      }, {})
    })

    const groupedDataDownloadExcel = computed(() => {
      const grouped = {}

      relatorioData.value.forEach(item => {
        const date = item.dataRegistroLogin.split('T')[0]
        if (!grouped[date]) {
          grouped[date] = []
        }
        grouped[date].push(item)
      })
      return grouped
    })

    async function downloadExcelRelatorio() {
      try {
        if (Object.keys(groupedDataDownloadExcel.value).length === 0 || arrayVazio.value) {
          this.$toast.warning('Sem dados para gerar relatório!')
          return
        }

        const workbook = new ExcelJS.Workbook()
        const worksheet = workbook.addWorksheet('Sheet1')

        worksheet.columns = [
          { header: 'Fila', key: 'filaNome', width: 20 },
          { header: 'Agente', key: 'agenteNome', width: 20 },
          { header: 'Tempo Logado', key: 'tempoLogado', width: 15 },
          { header: 'Tempo Pausa', key: 'tempoEmPausa', width: 15 },
          { header: 'Data', key: 'data', width: 15 },
        ]

        // eslint-disable-next-line no-restricted-syntax
        for (const date in groupedDataDownloadExcel.value) {
          // eslint-disable-next-line no-prototype-builtins
          if (groupedDataDownloadExcel.value.hasOwnProperty(date)) {
            const dataGroup = groupedDataDownloadExcel.value[date]

            dataGroup.forEach(item => {
              const dateObject = new Date(item.dataRegistroLogin)
              const formattedDate = `${dateObject.getDate().toString().padStart(2, '0')}/${(dateObject.getMonth() + 1).toString().padStart(2, '0')}/${dateObject.getFullYear()}`

              worksheet.addRow({
                filaNome: item.filaNome,
                agenteNome: item.agenteNome,
                tempoLogado: item.tempoLogado,
                tempoEmPausa: item.tempoEmPausa,
                data: formattedDate,
              })
            })
          }
        }

        const buffer = await workbook.xlsx.writeBuffer()

        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        FileSaver.saveAs(blob, 'Relatorio_equipe.xlsx')

        this.loadingButton = false
      } catch (error) {
        console.error('Erro durante a geração ou download do relatório:', error)
      }
    }

    const filtroPeriodoInicio = ref(getDataInicialMes())
    const filtroPeriodoFim = ref(getDataFinalMes())

    const { id } = storeToRefs(useUserStore())

    const menu1 = ref(false)
    const menu2 = ref(false)

    const formatDate = dates => {
      if (!dates) return null
      const [year, month, day] = dates.split('-')

      return `${day}/${month}/${year}`
    }

    const parseDate = dates => {
      if (!dates) return null
      const [day, month, year] = dates.split('/')

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }

    let dateFormatted = computed(() => formatDate(filtroPeriodoInicio.value))
    let computedDateFormatted = computed(() => formatDate(filtroPeriodoFim.value))

    watch(filtroPeriodoInicio, () => {
      dateFormatted = formatDate(filtroPeriodoInicio.value)
    })

    watch(filtroPeriodoFim, () => {
      computedDateFormatted = formatDate(filtroPeriodoFim.value)
    })

    async function getEquipes() {
      equipes.value = await EquipeService.getEquipesAtivas(id.value)
    }

    async function getAgentes() {
      agentes.value = await EquipeService.getAgentesAssociadosAEquipe(equipeSelecionada.value)
    }

    const convertMinutesToHours = totalMinutes => {
      const hours = Math.floor(totalMinutes / 60)
      const minutes = totalMinutes % 60

      const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`
      return formattedTime
    }

    async function getRelatorioEquipe() {
      arrayVazio.value = false
      loading.value = true

      if (Date.parse(filtroPeriodoFim.value) < Date.parse(filtroPeriodoInicio.value)) {
        Vue.$toast.warning('O periódo final deve ser menor que o periódo inicial!')
        loading.value = false
        return
      }

      const diferenca = Date.parse(filtroPeriodoFim.value) - Date.parse(filtroPeriodoInicio.value)
      const diferencaDias = diferenca / (1000 * 3600 * 24)
      if (diferencaDias >= 366) {
        Vue.$toast.warning('A diferença entre as datas deve ser de no máximo 180 dias!')
        loading.value = false
        return
      }

      if (equipeSelecionada.value) {
        try {
          const data = await RelatorioService.getRelatorioEquipe(equipeSelecionada.value, agenteSelecionado.value, filtroPeriodoInicio.value, filtroPeriodoFim.value)

          relatorioData.value = data.map(item => ({
            ...item,
            tempoLogado: convertMinutesToHours(item.tempoLogado),
            tempoEmPausa: convertMinutesToHours(item.tempoEmPausa),
          }))

          if (relatorioData.value.length === 0) {
            arrayVazio.value = true
          } else {
            arrayVazio.value = false
          }
          loading.value = false
          getAgentes()
        } catch {
          loading.value = false
        }
      } else {
        loading.value = false
      }
    }

    watch(equipeSelecionada, getRelatorioEquipe)

    return {
      equipes,
      agentes,
      equipeSelecionada,
      agenteSelecionado,
      loading,
      loadingButton,
      filtroPeriodoFim,
      filtroPeriodoInicio,
      dateFormatted,
      menu1,
      menu2,
      computedDateFormatted,
      relatorioData,
      arrayVazio,
      groupedDataDisplay,
      convertMinutesToHours,
      getAgentes,
      getEquipes,
      getRelatorioEquipe,
      handleSelecionarEquipe,
      parseDate,
      formatDate,
      downloadExcelRelatorio,
      icons: { mdiFileExcelOutline },
      validators: {
        required,
        select,
      },
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
